var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	73884: () => (loadSingleton("default", "react", false, () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(65043))))))),
	83136: () => (loadStrictVersion("default", "classnames", false, [1,2,3,2], () => (__webpack_require__.e(8139).then(() => (() => (__webpack_require__(98139))))))),
	55199: () => (loadSingleton("default", "antd", false, () => (Promise.all([__webpack_require__.e(6287), __webpack_require__.e(1127), __webpack_require__.e(3136), __webpack_require__.e(7469), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(51127))))))),
	52526: () => (loadSingleton("default", "@kne/react-intl", false, () => (Promise.all([__webpack_require__.e(3884), __webpack_require__.e(7558), __webpack_require__.e(3694), __webpack_require__.e(1032), __webpack_require__.e(6116)]).then(() => (() => (__webpack_require__(46116))))))),
	87558: () => (loadSingleton("default", "@kne/react-fetch", false, () => (__webpack_require__.e(3201).then(() => (() => (__webpack_require__(3201))))))),
	57469: () => (loadSingleton("default", "dayjs", false, () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(60446))))))),
	41846: () => (loadStrictVersion("default", "@kne/button-group", false, [2,0,1,24], () => (Promise.all([__webpack_require__.e(4805), __webpack_require__.e(3884), __webpack_require__.e(3136), __webpack_require__.e(5199), __webpack_require__.e(2526), __webpack_require__.e(7558), __webpack_require__.e(1988), __webpack_require__.e(4037), __webpack_require__.e(486), __webpack_require__.e(2061)]).then(() => (() => (__webpack_require__(24805))))))),
	51988: () => (loadSingleton("default", "@kne/responsive-utils", false, () => (__webpack_require__.e(9372).then(() => (() => (__webpack_require__(56991))))))),
	83694: () => (loadSingleton("default", "@kne/global-context", false, () => (__webpack_require__.e(8247).then(() => (() => (__webpack_require__(20628))))))),
	48781: () => (loadStrictVersion("default", "@kne/react-icon", false, [2,0,1,3], () => (Promise.all([__webpack_require__.e(3884), __webpack_require__.e(3136), __webpack_require__.e(2818)]).then(() => (() => (__webpack_require__(2818))))))),
	33444: () => (loadStrictVersion("default", "prop-types", false, [1,15,8,1], () => (__webpack_require__.e(5173).then(() => (() => (__webpack_require__(65173))))))),
	96418: () => (loadStrictVersion("default", "@kne/use-ref-callback", false, [2,0,1,2], () => (__webpack_require__.e(9019).then(() => (() => (__webpack_require__(81400))))))),
	61032: () => (loadStrictVersion("default", "react-intl", false, [1,6,2,10], () => (__webpack_require__.e(86).then(() => (() => (__webpack_require__(60086))))))),
	3037: () => (loadStrictVersion("default", "@kne/is-empty", false, [1,1,0,1], () => (__webpack_require__.e(4818).then(() => (() => (__webpack_require__(32437))))))),
	13050: () => (loadSingleton("default", "@kne/remote-loader", false, () => (Promise.all([__webpack_require__.e(8601), __webpack_require__.e(8081)]).then(() => (() => (__webpack_require__(88601))))))),
	25806: () => (loadStrictVersion("default", "color", false, [1,4,2,3], () => (__webpack_require__.e(2995).then(() => (() => (__webpack_require__(42995))))))),
	71298: () => (loadStrictVersion("default", "simplebar", false, [1,6,3,0], () => (Promise.all([__webpack_require__.e(1287), __webpack_require__.e(7084)]).then(() => (() => (__webpack_require__(7084))))))),
	10986: () => (loadStrictVersion("default", "@kne/use-control-value", false, [2,0,1,7], () => (Promise.all([__webpack_require__.e(4037), __webpack_require__.e(4712)]).then(() => (() => (__webpack_require__(72331))))))),
	10486: () => (loadSingleton("default", "react-dom", false, () => (__webpack_require__.e(7950).then(() => (() => (__webpack_require__(97950))))))),
	34581: () => (loadStrictVersion("default", "simplebar-react", false, [1,3,3,0], () => (Promise.all([__webpack_require__.e(1287), __webpack_require__.e(4941)]).then(() => (() => (__webpack_require__(57322))))))),
	38726: () => (loadStrictVersion("default", "@kne/scroll-loader", false, [2,0,1,13], () => (Promise.all([__webpack_require__.e(4581), __webpack_require__.e(1599)]).then(() => (() => (__webpack_require__(83980))))))),
	26829: () => (loadStrictVersion("default", "@kne/react-file", false, [2,0,1,43], () => (Promise.all([__webpack_require__.e(8867), __webpack_require__.e(1144), __webpack_require__.e(3884), __webpack_require__.e(3136), __webpack_require__.e(5199), __webpack_require__.e(2526), __webpack_require__.e(7558), __webpack_require__.e(7469), __webpack_require__.e(1846), __webpack_require__.e(3694), __webpack_require__.e(4037), __webpack_require__.e(986), __webpack_require__.e(486), __webpack_require__.e(1582), __webpack_require__.e(2061), __webpack_require__.e(5087), __webpack_require__.e(8655)]).then(() => (() => (__webpack_require__(46031))))))),
	3803: () => (loadStrictVersion("default", "@kne/react-enum", false, [2,0,1,16], () => (Promise.all([__webpack_require__.e(1125), __webpack_require__.e(3884), __webpack_require__.e(7558), __webpack_require__.e(3694), __webpack_require__.e(4037), __webpack_require__.e(3037)]).then(() => (() => (__webpack_require__(51125))))))),
	70720: () => (loadStrictVersion("default", "@kne/use-click-outside", false, [2,0,2,1], () => (__webpack_require__.e(1820).then(() => (() => (__webpack_require__(99439))))))),
	44352: () => (loadStrictVersion("default", "@kne/super-select", false, [2,0,1,39], () => (Promise.all([__webpack_require__.e(7930), __webpack_require__.e(2372), __webpack_require__.e(5016), __webpack_require__.e(7558), __webpack_require__.e(7469), __webpack_require__.e(1846), __webpack_require__.e(1988), __webpack_require__.e(3694), __webpack_require__.e(4037), __webpack_require__.e(3037), __webpack_require__.e(986), __webpack_require__.e(486), __webpack_require__.e(4581), __webpack_require__.e(8726), __webpack_require__.e(2007), __webpack_require__.e(2061), __webpack_require__.e(9859)]).then(() => (() => (__webpack_require__(42210))))))),
	65317: () => (loadStrictVersion("default", "lodash", false, [1,4,17,23], () => (__webpack_require__.e(3536).then(() => (() => (__webpack_require__(53536))))))),
	78491: () => (loadStrictVersion("default", "@kne/use-simulation-blur", false, [2,0,1,2], () => (Promise.all([__webpack_require__.e(720), __webpack_require__.e(9998)]).then(() => (() => (__webpack_require__(87617))))))),
	32007: () => (loadStrictVersion("default", "@kne/info-page", false, [2,0,2,11], () => (Promise.all([__webpack_require__.e(7930), __webpack_require__.e(6070), __webpack_require__.e(3884), __webpack_require__.e(3136), __webpack_require__.e(5199), __webpack_require__.e(7469), __webpack_require__.e(1846), __webpack_require__.e(1988), __webpack_require__.e(4037), __webpack_require__.e(3037), __webpack_require__.e(913)]).then(() => (() => (__webpack_require__(85971))))))),
	1582: () => (loadStrictVersion("default", "@kne/create-deferred", false, [2,0,1,0], () => (__webpack_require__.e(107).then(() => (() => (__webpack_require__(10107))))))),
	74529: () => (loadStrictVersion("default", "@kne/compose", false, [2,0,1,0], () => (__webpack_require__.e(7240).then(() => (() => (__webpack_require__(37240))))))),
	94679: () => (loadSingleton("default", "react-router-dom", false, () => (Promise.all([__webpack_require__.e(3245), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(53245))))))),
	28598: () => (loadStrictVersion("default", "@kne/react-filter", false, [1,1,0,11], () => (Promise.all([__webpack_require__.e(9549), __webpack_require__.e(9967), __webpack_require__.e(3884), __webpack_require__.e(3136), __webpack_require__.e(5199), __webpack_require__.e(2526), __webpack_require__.e(7469), __webpack_require__.e(1988), __webpack_require__.e(486), __webpack_require__.e(4352), __webpack_require__.e(9917), __webpack_require__.e(935)]).then(() => (() => (__webpack_require__(79967))))))),
	18081: () => (loadStrictVersion("default", "@kne/ensure-slash", false, [2,0,1,0], () => (__webpack_require__.e(5024).then(() => (() => (__webpack_require__(5024))))))),
	29871: () => (loadStrictVersion("default", "@kne/flex-box", false, [2,0,1,1], () => (Promise.all([__webpack_require__.e(8346), __webpack_require__.e(3884), __webpack_require__.e(5199), __webpack_require__.e(2061)]).then(() => (() => (__webpack_require__(38346))))))),
	25344: () => (loadStrictVersion("default", "@kne/table-page", false, [2,0,1,13], () => (Promise.all([__webpack_require__.e(7930), __webpack_require__.e(4455), __webpack_require__.e(8998), __webpack_require__.e(486), __webpack_require__.e(8598), __webpack_require__.e(4870), __webpack_require__.e(9245)]).then(() => (() => (__webpack_require__(96617))))))),
	25849: () => (loadStrictVersion("default", "@kne/form-info", false, [2,0,1,10], () => (Promise.all([__webpack_require__.e(7930), __webpack_require__.e(5090), __webpack_require__.e(2007), __webpack_require__.e(9871), __webpack_require__.e(5691)]).then(() => (() => (__webpack_require__(85958))))))),
	51941: () => (loadStrictVersion("default", "use-debounce", false, [1,9,0,4], () => (__webpack_require__.e(589).then(() => (() => (__webpack_require__(2970))))))),
	53202: () => (loadStrictVersion("default", "react-avatar-editor", false, [1,13,0,0], () => (__webpack_require__.e(4872).then(() => (() => (__webpack_require__(34872))))))),
	77339: () => (loadStrictVersion("default", "@kne/phone-number-input", false, [2,0,1,5], () => (Promise.all([__webpack_require__.e(8701), __webpack_require__.e(2601)]).then(() => (() => (__webpack_require__(64982))))))),
	80071: () => (loadStrictVersion("default", "@kne/react-pdf-sign", false, [1,1,1,6], () => (Promise.all([__webpack_require__.e(8867), __webpack_require__.e(7326), __webpack_require__.e(2061), __webpack_require__.e(2429)]).then(() => (() => (__webpack_require__(97326))))))),
	89946: () => (loadSingleton("default", "axios", false, () => (__webpack_require__.e(4062).then(() => (() => (__webpack_require__(74062))))))),
	14857: () => (loadStrictVersion("default", "use-debounce", false, [1,9,0,4], () => (__webpack_require__.e(925).then(() => (() => (__webpack_require__(3306))))))),
	98434: () => (loadSingleton("default", "@kne/react-form-antd", false, () => (Promise.all([__webpack_require__.e(7459), __webpack_require__.e(3136), __webpack_require__.e(7469), __webpack_require__.e(5317), __webpack_require__.e(7536)]).then(() => (() => (__webpack_require__(77459))))))),
	62061: () => (loadStrictVersion("default", "@kne/use-resize", false, [2,0,1,1], () => (Promise.all([__webpack_require__.e(4037), __webpack_require__.e(1536)]).then(() => (() => (__webpack_require__(19155))))))),
	85691: () => (loadStrictVersion("default", "@kne/react-form-plus", false, [2,0,1,5], () => (Promise.all([__webpack_require__.e(486), __webpack_require__.e(7536), __webpack_require__.e(8683)]).then(() => (() => (__webpack_require__(91064))))))),
	88701: () => (loadStrictVersion("default", "libphonenumber-js", false, [1,1,10,28], () => (Promise.all([__webpack_require__.e(2931), __webpack_require__.e(7591)]).then(() => (() => (__webpack_require__(27591))))))),
	75087: () => (loadStrictVersion("default", "@kne/react-file-type", false, [1,1,0,5], () => (__webpack_require__.e(1180).then(() => (() => (__webpack_require__(51180))))))),
	80988: () => (loadStrictVersion("default", "@kne/super-select-plus", false, [2,0,1,2], () => (Promise.all([__webpack_require__.e(2372), __webpack_require__.e(1036), __webpack_require__.e(7558), __webpack_require__.e(9859), __webpack_require__.e(108)]).then(() => (() => (__webpack_require__(48655))))))),
	37536: () => (loadSingleton("default", "@kne/react-form", false, () => (Promise.all([__webpack_require__.e(8715), __webpack_require__.e(3549), __webpack_require__.e(4037), __webpack_require__.e(3037), __webpack_require__.e(4529), __webpack_require__.e(1670)]).then(() => (() => (__webpack_require__(13549))))))),
	36078: () => (loadStrictVersion("default", "use-debounce", false, [1,9,0,4], () => (__webpack_require__.e(3120).then(() => (() => (__webpack_require__(80739))))))),
	87321: () => (loadSingleton("default", "@kne/use-event", false, () => (__webpack_require__.e(4679).then(() => (() => (__webpack_require__(47060))))))),
	69859: () => (loadStrictVersion("default", "use-debounce", false, [1,9,0,4], () => (__webpack_require__.e(6873).then(() => (() => (__webpack_require__(69254))))))),
	28990: () => (loadStrictVersion("default", "use-debounce", false, [1,9,0,4], () => (__webpack_require__.e(7124).then(() => (() => (__webpack_require__(84743))))))),
	76441: () => (loadStrictVersion("default", "react-sortablejs", false, [1,6,1,4], () => (Promise.all([__webpack_require__.e(5786), __webpack_require__.e(9798)]).then(() => (() => (__webpack_require__(15786))))))),
	73766: () => (loadStrictVersion("default", "sortablejs", false, [1,1,15,0], () => (__webpack_require__.e(1797).then(() => (() => (__webpack_require__(11797))))))),
	76337: () => (loadStrictVersion("default", "classnames", false, [1,2,3,2], () => (__webpack_require__.e(1833).then(() => (() => (__webpack_require__(71833)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"486": [
		10486
	],
	"720": [
		70720
	],
	"935": [
		80988
	],
	"986": [
		10986
	],
	"1032": [
		61032
	],
	"1582": [
		1582
	],
	"1670": [
		36078,
		87321
	],
	"1846": [
		41846
	],
	"1988": [
		51988
	],
	"2007": [
		32007
	],
	"2061": [
		62061
	],
	"2526": [
		52526
	],
	"3037": [
		3037
	],
	"3136": [
		83136
	],
	"3443": [
		14857,
		98434
	],
	"3444": [
		33444
	],
	"3694": [
		83694
	],
	"3803": [
		3803
	],
	"3884": [
		73884
	],
	"4037": [
		96418
	],
	"4345": [
		89946
	],
	"4352": [
		44352
	],
	"4529": [
		74529
	],
	"4541": [
		25344,
		25849,
		51941,
		53202,
		77339,
		80071
	],
	"4581": [
		34581
	],
	"4870": [
		28990,
		76441
	],
	"5087": [
		75087
	],
	"5199": [
		55199
	],
	"5317": [
		65317
	],
	"5691": [
		85691
	],
	"6829": [
		26829
	],
	"7160": [
		13050,
		25806,
		71298
	],
	"7469": [
		57469
	],
	"7536": [
		37536
	],
	"7558": [
		87558
	],
	"8081": [
		18081
	],
	"8434": [
		98434
	],
	"8491": [
		78491
	],
	"8598": [
		28598
	],
	"8701": [
		88701
	],
	"8726": [
		38726
	],
	"8781": [
		48781
	],
	"9798": [
		73766,
		76337
	],
	"9859": [
		69859
	],
	"9871": [
		29871
	],
	"9917": [
		94679
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}